import React from 'react';

function getLiveInfo(score) {
    let final = [];

    if (score.periodo?.length > 0) {
        final.push(<span className='liveMinutes__periodo' key={1}>{score.periodo}</span>);
    }

    if (score.currentMinute) {
        if (final == null)  {
            final = '';
        }
        final.push(<span className='liveMinutes__minute' key={2}>{score.currentMinute}</span>);
    }

    return final;
}

export default function LiveMinutes(props) {
    if (props.score == null) {
        return null;
    }

    const info = getLiveInfo(props.score);

    if (info.length === 0) {
        return null;
    }

    return info;
}
